import { priceField } from '../../../components/table/CommonFields';

const fields = {
  config: { columns: 1 },
  fields: [
    priceField(1, 'securityDepositAmount', 'Kaucja', false, '900.00', undefined)
  ]
};

export default fields;
